import Delete from './Delete';

export default Delete;